<template>
  <div class="header">
    <div class="header_title">周六福开票系统</div>
    <div>
      <span class="header_name">{{userName}}</span>
      <span style="cursor:pointer;" @click="dropOut">
        <span class="el-icon-switch-button"></span>
        <span class="dropOut">退出</span>
      </span>
      <el-dialog
        title="提示"
        :append-to-body="true"
        :visible.sync="centerDialogVisible"
        width="30%"
        center
      >
        <span>确认退出吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="droplogin">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      userName: ""
    }
  },
  mounted() {
    this.userName = JSON.parse(window.localStorage.getItem("userName"));
  },
  methods: {
    // 点击退出
    dropOut() {
      this.centerDialogVisible = true
    },
    droplogin() {
      this.centerDialogVisible = false
      window.location.href = "logout";
    }
  }
};
</script>
<style lang="scss" scoped>
.header {
  z-index: 999999;
  height: 60px;
  width: 100%;
  background: #001c40;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header_title {
    font-weight: bold;
    margin-left: 40px;
  }
  .header_name {
    margin-right: 20px;
  }
  .el-icon-switch-button {
    margin-right: 5px;
  }
  .dropOut {
    margin-right: 30px;
  }
}
/deep/.el-pagination .btn-next {
  min-width: 50px !important;
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: center;
}
/deep/.el-button + .el-button {
  margin-left: 35px;
}
.el-dialog__wrapper {
  top: 200px;
}
</style>